import { decorate, inject, injectable } from "inversify";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  RegisterOptions
} from "vuex-class-modules";

import { UserInfo } from "./models";
import { UserInfoService } from "./services";

try {
  decorate(injectable(), VuexModule);
  // eslint-disable-next-line
} catch {}

@Module
@injectable()
export default class ProfileStore extends VuexModule {
  userInfo: null | UserInfo = null;

  constructor(
    @inject(UserInfoService) private userInfoClient: UserInfoService,
    @inject("VuexModuleOptions") options: (className: string) => RegisterOptions
  ) {
    super(options("ProfileStore"));
  }

  get userName() {
    return (
      this.userInfo && this.userInfo.firstName + " " + this.userInfo.lastName
    );
  }

  get loginName() {
    return this.userInfo && this.userInfo.loginName;
  }

  get userMail() {
    return this.userInfo && this.userInfo.userEmailId;
  }

  get company() {
    let company = this.userInfo && this.userInfo.companyDetailsRes;
    const branch = company;
    while (company && company.parent) {
      company = company.parent;
    }
    return (
      company && {
        name: company.companyName,
        mail: company.companyEmailId,
        accountNr: company.as2Nr,
        branch: branch && branch != company ? branch.companyName : null
      }
    );
  }

  @Mutation
  reset() {
    this.userInfo = null;
  }

  @Mutation
  updateUserInfo(info: UserInfo) {
    this.userInfo = info;
  }

  @Action
  async loadData() {
    const response = await this.userInfoClient.getUser().toPromise();
    this.updateUserInfo(response);
  }
}
